<ng-container *ngFor="let actionItem of actions || []">
	<custom-btn (click)="onClick(actionItem.id + '_ALL')"
				*ngIf="actionItem.id == 'ACT_IMPORT_PREVIEW'"
				[iconButton]="true"
				[iconClasses]="actionItem.icon"
				[iconColor]="'green'"
				matTooltip="{{ 'ACT_IMPORT_PREVIEW' | translate }}">
	</custom-btn>

	<custom-btn (click)="onClick(actionItem.id+'_ALL')"
				*ngIf="actionItem.id == 'ACT_EXPORT_CSV'"
				[iconButton]="true"
				[iconClasses]="'table_chart'"
				[iconColor]="'green'"
				matTooltip="{{ 'LABEL_EXPORT_CSV' | translate }}">
	</custom-btn>

	<custom-btn (click)="onClick(actionItem.id+'_ALL')"
				*ngIf="actionItem.id == 'ACT_BULK_EDIT'"
				[iconButton]="true"
				[iconClasses]="actionItem.icon"
				[iconColor]="'green'"
				matTooltip="{{ 'ACT_BULK_EDIT' | translate }}">
	</custom-btn>

	<custom-btn
		(click)="onClick(actionItem.id+'_' +detailId)"
		*ngIf="actionItem.id == 'ACT_MONITOR_UPLOAD_ATTACHMENT'"
		matTooltip="{{ 'LABEL_MONITOR_UPLOAD_ATTACHMENT' | translate }}">
		{{ 'LABEL_MONITOR_UPLOAD_ATTACHMENT' | translate }}
	</custom-btn>

	<mat-slide-toggle *ngIf="actionItem.id == 'ACT_VIEW_DUPLICATED'"
					  (change)="onClick(actionItem.id+'_' +$event.checked)">
		<span style="margin-left: 10px;">{{ "ACT_VIEW_DUPLICATED" | translate }}</span>
	</mat-slide-toggle>
</ng-container>
